import Parse from '../../parse'

const getters = {
  Parse: () => {
    return Parse
  }
}

export default {
  getters
}
